import { InjectionToken } from '@angular/core';
import { Bundle, FormTemplate, Pair, PairGif } from '@nrwl/rx-models';

export type AddNewGalleryPlaceholder = {
  functionality: 'add_new';
  noDraggable: true;
};

export type GalleryPreviewData = Pair | PairGif | Bundle | FormTemplate;
export type GalleryListItem = GalleryPreviewData | AddNewGalleryPlaceholder;

/** Injection token that can be used to access the data that was passed in to a preview component. */
export const PREVIEW_DATA = new InjectionToken<GalleryPreviewData>('rx.gallery-preview');
